import { makeAutoObservable } from "mobx";
import { Report } from "../../models/Report";
import { ReportApi } from "../../apis/Report";

export class ReportManagementPageModel {
    unprocessedReports: Report[] = [];
    processedReports: Report[] = [];
    selectedStatus: number = 0; // 0-全部 1-待处理 2-已处理
    loading: boolean = false;

    constructor() {
        makeAutoObservable(this);
    }

    setSelectedStatus = (status: number) => {
        this.selectedStatus = status;
    }

    loadReports = async () => {
        this.loading = true;
        try {
            if (this.selectedStatus === 0 || this.selectedStatus === 1) {
                this.unprocessedReports = await ReportApi.getUnprocessedReports();
            }
            if (this.selectedStatus === 0 || this.selectedStatus === 2) {
                this.processedReports = await ReportApi.getProcessedReports();
            }
        } finally {
            this.loading = false;
        }
    }

    markAsProcessed = async (reportId: number) => {
        const success = await ReportApi.markAsProcessed({ reportId });
        if (success) {
            await this.loadReports();
        }
        return success;
    }

    updateReportResult = async (reportId: number, result: string) => {
        const success = await ReportApi.updateReportResult({ reportId, result });
        if (success) {
            await this.loadReports();
        }
        return success;
    }

    getDisplayReports = (): Report[] => {
        if (this.selectedStatus === 0) {
            return [...this.unprocessedReports, ...this.processedReports];
        } else if (this.selectedStatus === 1) {
            return this.unprocessedReports;
        } else {
            return this.processedReports;
        }
    }
} 